// src/services/usageReportsApi.js
import apiService from './apiService';

const usageReportsApi = {
  // Platform-wide usage summary (per-customer totals, AI usage, active days).
  getSummary: (params = {}) => apiService.get('/usage-reports/summary', { params }),

  // AI-tool-specific report (which AI features are used, by whom, how often).
  getAiUsage: (params = {}) => apiService.get('/usage-reports/ai', { params }),

  // Self-service: the logged-in user's own activity history.
  getMyHistory: (params = {}) => apiService.get('/usage-reports/my-history', { params }),

  // Full activity timeline for a single customer.
  getUserTimeline: (userId, params = {}) => apiService.get(`/usage-reports/user/${userId}`, { params }),
};

export default usageReportsApi;
